import React from 'react'
import classNames from 'classnames'
import {
  getItemByValue,
  getParentLabels,
  isEqual,
} from '@yk-component/yk-util/dist/esm'
import { SelectLabelSingleProps } from './interface'
import { defaultClearIcon, defaultDropIcon } from './SelectLabel'

const Single = <V=unknown>(props: SelectLabelSingleProps<V>) => {
  const {
    value,
    data = [],
    placeholder = '请选择',
    customText,
    onlyShowLeaf,
    clearIcon,
    onChange,
    dropIcon,
    isEqualFn = isEqual,
    className,
    style,
    open,
    disabled,
  } = props

  const text = () => {
    const item = getItemByValue(value, data, isEqualFn)
    if (!item && value === undefined) return undefined
    if (!item) {
      return value?.toString()
    }
    if (onlyShowLeaf) {
      return item.label
    }
    const labels = getParentLabels(value, data, isEqualFn)
    const label: React.ReactNode[] = labels?.map((l, i) => [l, <span key={i}>/</span>]) || []
    label.push(item.label)
    return label
  }

  return (
    <span
      className={classNames(className, 'zySelectLabelWrap')}
      style={style}
      data-open={open}
      data-active={(value ?? undefined) !== undefined}
      data-clearable={clearIcon !== false && value !== undefined}
      data-disabled={disabled}
    >
      <span className="zySelectLabel">
        <span className="zySelectLabelText">
          {customText?.(value, data) || text() || placeholder}
        </span>
        {dropIcon !== false
          && (dropIcon === true || dropIcon === undefined
            ? defaultDropIcon
            : dropIcon)}
        {clearIcon !== false && value !== undefined && (
          <span
            className="zySelectLabelClear"
            onClick={(ev) => {
              ev.stopPropagation()
              onChange?.({ value: undefined, event: ev })
            }}
          >
            {clearIcon === true || clearIcon === undefined
              ? defaultClearIcon
              : clearIcon}
          </span>
        )}
      </span>
    </span>
  )
}

export default Single
